 /**
 * v-hasRole 角色权限处理
 */

import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const roles = store.getters && store.getters["right/getRole"]
    if (value && value instanceof Array && value.length > 0) {
      const hasRole = value.some(role => {
        return role===roles
      })
      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置角色权限标签值"`)
    }
  }
}

